import api from '../utils/api';

// Fetch all teachers
export const getAllTeachers = async (headers) => {
 
  try {
    const response = await api.get('/api/teachers',  headers );
    console.log("teachers", response)
    return response.data;
  } catch (error) {
    console.error('Error fetching all teachers:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific teacher by ID
export const getTeacherById = async (id, headers) => {
  try {
    const response = await api.get(`/api/teachers/${id}`,  headers );
    console.log("Fetched teacher data:", response.data); // Debugging statement
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new teacher
export const createTeacher = async (teacherData, headers) => {
  try {
    const response = await api.post('/api/teachers', teacherData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating teacher:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing teacher
export const updateTeacher = async (id, teacherData, headers) => {
  try {
    const response = await api.put(`/api/teachers/${id}`, teacherData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating teacher:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a teacher
export const deleteTeacher = async (id, headers) => {
  try {
    const response = await api.delete(`/api/teachers/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting teacher:', error.response ? error.response.data : error.message);
    throw error;
  }
};
